import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { CookiesProvider } from 'react-cookie';

import './index.css';
import './i18n';
import App from './App';
import store from './redux/store';
import { PaymentProvider } from './context/PaymentContext';

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
    <CookiesProvider>
      <Provider store={store}>
        <PaymentProvider>
          <App />
        </PaymentProvider>
      </Provider>
    </CookiesProvider>
  </React.StrictMode>
);
